import * as React from 'react';
import AdminWrapper from '../../AdminWrapper';
import { withRouter } from 'react-router-dom';
import { RootState } from '../../../../store/store';
import { connect } from 'react-redux';
import { confirmDialog, showDialog } from '../../../Dialog/actions';
import RbLabel, { LabelSize } from '../../../../bosch-react/components/label/RbLabel';
import { IconButton, TooltipHost } from 'office-ui-fabric-react';
import { tooltipHostStyles } from '../types';
import { Icon, ILabelStyles, IPivotItemProps, IStyleSet, Label, Pivot, PivotItem } from '@fluentui/react';
import UserRole from './UserRole/UserRole';
import FeaturePermission from './Feature/FeaturePermission';
import FileProvisioner from './Provisioner/FileProvisioner';
import Constants from '../../../../core/libraries/Constants';


interface IProps {
    history: any
    userProfile: any,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
}

interface IState {

}

class AppSetting extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }
    labelStyles: Partial<IStyleSet<ILabelStyles>> = {
        root: { marginTop: 10 },
    };

    async componentDidMount() {
        await this.handleProfileChanged();

    }
    async componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.userProfile !== this.props.userProfile) {
            await this.handleProfileChanged();
        }
    }
    handleProfileChanged() {
        const { userProfile } = this.props
        if (!!userProfile) {
            if (userProfile.permissions?.checkHasPermission([Constants.PERMISSIONS.CONFIGURATION]) === false) {
                this.props.confirmDialog(
                    "No Permission",
                    "You do not have permission to access this page.",
                    true,
                    () => {
                        window.location.href = process.env.REACT_APP_HOME!;
                    }
                );
            }
        }
    }



    _customRenderer(
        link?: IPivotItemProps,
        defaultRenderer?: (link?: IPivotItemProps) => JSX.Element | null,
    ): JSX.Element | null {
        if (!link || !defaultRenderer) {
            return null;
        }

        return (
            <span style={{ flex: '0 1 100%' }}>
                {defaultRenderer({ ...link, itemIcon: undefined })}
                <Icon iconName={link.itemIcon} style={{ color: 'red' }} />
            </span>
        );
    }
    render() {
        return (

            <AdminWrapper history={this.props.history}>
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm4">
                            <div className="ms-Grid">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12">
                                        <RbLabel className="header-title" size={LabelSize.Large}>
                                            {" "}
                                            Application Setting{" "}
                                        </RbLabel>
                                        <TooltipHost
                                            content={"Manage users, features, and document provisioning settings in one place — including user roles, available features, and weekly FEBER document destinations."}
                                            styles={tooltipHostStyles}
                                            calloutProps={{ gapSpace: 10 }}
                                        >
                                            <IconButton
                                                iconProps={{ iconName: "Info" }}
                                                ariaLabel="Tab information"
                                                title="Tab information"
                                            />
                                        </TooltipHost>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12" style={{ marginLeft: "8px" }}>
                                <Pivot aria-label="Count and Icon Pivot Example">
                                        // ...existing code...
                                    <PivotItem headerText="User Role Management" itemIcon="People">
                                        <TooltipHost
                                            content={"Add, edit, or delete roles, and manage user assignments within each role."}
                                            styles={tooltipHostStyles}
                                            calloutProps={{ gapSpace: 10 }}
                                        >
                                            <IconButton
                                                iconProps={{ iconName: "Info" }}
                                                ariaLabel="Tab information"
                                                title="Tab information"
                                            />
                                        </TooltipHost>
                                        <UserRole />
                                    </PivotItem>
                                    <PivotItem headerText="Feature Management" itemIcon="Settings">
                                        <TooltipHost
                                            content={"Control system-wide feature availability and manage beta access for specific users, groups, or roles"}
                                            styles={tooltipHostStyles}
                                            calloutProps={{ gapSpace: 10 }}
                                        >
                                            <IconButton
                                                iconProps={{ iconName: "Info" }}
                                                ariaLabel="Tab information"
                                                title="Tab information"
                                            />
                                        </TooltipHost>
                                        <FeaturePermission />
                                    </PivotItem>
                                    <PivotItem headerText="Provisioner Configuration" itemIcon="ConfigurationSolid">
                                        <TooltipHost
                                            content={"Manage automated file provisioning configurations for weekly jobs that send files from blob storage to various destinations."}
                                            styles={tooltipHostStyles}
                                            calloutProps={{ gapSpace: 10 }}
                                        >
                                            <IconButton
                                                iconProps={{ iconName: "Info" }}
                                                ariaLabel="Tab information"
                                                title="Tab information"
                                            />
                                        </TooltipHost>
                                        <FileProvisioner />
                                    </PivotItem>
                                </Pivot>
                            </div>
                        </div>
                    </div>
                </div>

            </AdminWrapper>
        );
    }
}
const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});
export default withRouter(connect(mapStateToProps, { confirmDialog, showDialog })(AppSetting));